import { createRouter, createWebHistory } from 'vue-router'

import BaseLayout from '@/components/BaseLayout'
import App from '@/App.vue'

export const constantRoutes = [

  // 项目默认跳转根据域名匹配  千鸟和云看看不同
  // 千鸟项目默认跳转
  {
    path: '/',
    component: BaseLayout,
    redirect: 'first',
    children: [{
      name: 'LeftList',
      path: 'first',
      component: () => import('@/views/leftlist/index'),
    }]
  },
  {
    path: '/dist',
    component: BaseLayout,
    redirect: 'first',
    children: [{
      name: 'LeftList',
      path: 'first',
      component: () => import('@/views/leftlist/index'),
    }]
  },
  {
    path: '/dist/lang/index',
    component: BaseLayout,
    children: [{
      name: 'Lang',
      path: '/dist/lang/index',
      component: () => import('@/views/leftlist/index'),
    }]
  },

  {
    path: '/dist/content',
    component: BaseLayout,
    children: [{
      name: 'Content',
      path: 'index/:data',
      component: () => import('@/views/content/index'),
    }]
  },

  {
    name: 'CustomerService',
    path: '/dist/customerService',
    component: () => import('@/views/customerService/index'),
    meta: { title: "客服中心" },
  },

  {
    name: 'Form',
    path: '/dist/form',
    component: () => import('@/views/form/index'),
  },
  {
    name: 'Contact',
    path: '/dist/contact',
    component: () => import('@/views/other/contact'),
  },
  {
    name: 'Cancellation',
    path: '/dist/cancellation',
    component: () => import('@/views/other/cancellation'),
  },
  {
    name: 'PlayBack',
    path: '/dist/playback',
    component: () => import('@/views/other/playback'),
  },
  // 404 page must be placed at the end !!!
  // { path: '*', redirect: '/404', hidden: true }
  // 智能客服对话框
  {
    name: 'AiVoiceFAQ',
    path: '/dist/aiVoiceFAQ',
    component: () => import('@/views/aiVoiceFAQ/index'),
    meta: { title: "小度AI智能语音服务FAQ" },
  },
  {
    name: 'CustomerServiceChat',
    path: '/dist/CustomerServiceChat',
    component: () => import('@/views/customerServiceChat/index'),
    meta: { title: "专属客服" },
  },

  //   云看看项目默认跳转
  // {
  //   path: '/',
  //   name: 'App',
  //   component: App,
  //   meta: { title: '首页' },
  //   redirect: '/dist/cloudSee/help',
  // },
  // {
  //   path: '/dist',
  //   component: App,
  //   redirect: '/dist/cloudSee/help',
  // },

  // 云看看
  {
    name: 'cloudSeeCustomerService',
    path: '/dist/cloudSeeCustomerService',
    component: () => import('@/views/cloudSee/customerService/index'),
    meta: { title: "专属客服" },
  },
  {
    name: 'CloudSeeHelp',
    path: '/dist/cloudSee/help',
    component: () => import('@/views/cloudSee/help/index'),
    meta: { title: "pageTitle" },
  },
  // 视频播放
  {
    name: 'CloudSeePlayBack',
    path: '/dist/cloudSee/playback',
    component: () => import('@/views/cloudSee/playback/index'),
    meta: { title: "帮助与反馈" },
  },
  // 问题详情
  {
    name: 'CloudSeeProblem',
    path: '/dist/cloudSee/problem',
    component: () => import('@/views/cloudSee/problem/index'),
    meta: { title: "帮助与反馈" },
  },
  {
    name: 'CloudSeeProblemDetail',
    path: '/dist/cloudSee/problemDetail',
    component: () => import('@/views/cloudSee/problem/detail'),
    meta: { title: "帮助与反馈" },
  },
  {
    name: 'UserTerms',
    path: '/dist/agreed/userTerms',
    component: () => import('@/views/htmlPage/userTerms/index'),
    meta: { title: "usertermsTitle" },
  },
  {
    name: 'PrivacyPolicy',
    path: '/dist/agreed/privacyPolicy',
    component: () => import('@/views/htmlPage/privacyPolicy/index'),
    meta: { title: "privacyPolicyTitle" },
  },


  // 飞利浦隐私政策
  {
    name: 'PhilipsPrivacy',
    path: '/dist/agreed/philipsPrivacy',
    component: () => import('@/views/htmlPage/philips-privacy/index'),
    meta: { title: "privacyPolicyTitle" },
  },
  // 飞利浦用户协议
  {
    name: 'PhilipsUserTerms',
    path: '/dist/agreed/philipsUserTerms',
    component: () => import('@/views/htmlPage/philips-userTerms/index'),
    meta: { title: "usertermsTitle" },
  },
  // 飞利浦自动续费协议
  {
    name: 'PhilipsAutoRenew',
    path: '/dist/agreed/philipsAutoRenew',
    component: () => import('@/views/htmlPage/philips-autoRenew/index'),
    meta: { title: "philipsAutoRenewTitle" },
  },
  //  飞利浦云服务购买
  {
    name: 'PhilipsCloudService',
    path: '/dist/agreed/philipsCloudService',
    component: () => import('@/views/htmlPage/philips-cloudServiceDesc/index'),
    meta: { title: "philipsCloudServiceTitle" },
  },
  // 千鸟自动续费协议
  {
    name: 'birdsAutoRenew',
    path: '/dist/agreed/birdsAutoRenew',
    component: () => import('@/views/htmlPage/birds-autoRenew/index'),
    meta: { title: "philipsAutoRenewTitle" },
  },
  // 云看看自动续费协议
  {
    name: 'cloudSeeAutoRenew',
    path: '/dist/agreed/cloudSeeAutoRenew',
    component: () => import('@/views/htmlPage/cloudSee-autoRenew/index'),
    meta: { title: "philipsAutoRenewTitle" },
  },
]

const create = () => createRouter({
  mode: 'history', // require service support
  base: '/dist/',
  history: createWebHistory(),
  routes: constantRoutes
})

const router = create()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = create()
  router.matcher = newRouter.matcher // reset router
}

export default router
